module.exports = __webpack_public_path__ + "static/media/loupe-dark.6530da44.svg";